module.exports = __webpack_public_path__ + "files/3c7d18415efa411a78dba54e538ccc01.svg";